import { RootState } from "redux/store";
import { TokenData } from "./models";
export const getTokens = (state: RootState) => state.auth as TokenData;
export const getIsLoading = (state: RootState) =>  state.auth.isLoading;
export const getErrorMessage = (state: RootState) => state.auth.error;
export const getIsLogin = (state: RootState) => !!state.auth.access;